import React from "react";
import { Box, Button } from "@mui/material";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import AppDialog from "../common/AppDialog";
import LogsView, { LogsScope } from "./LogsView";

/**
 * The Logs popup for a task job or a single task. It is only a frame: the same
 * `LogsView` body is mounted on the task workspace page, so a task reads exactly
 * the same way whether it is opened from the panel or from its own page.
 */
export default function LogsDialog({
  open,
  onClose,
  title,
  scope,
  canEdit,
  readOnlyReason,
  initialSearch,
}: {
  open: boolean;
  onClose: () => void;
  title: string;
  scope: LogsScope | null;
  /** May the operator mark files as manually resolved (anywhere but Client View). */
  canEdit: boolean;
  /** Why not, when canEdit is false; null when they may act. */
  readOnlyReason: string | null;
  /** Search prefilled when the scope opens - a deep link onto one employee. */
  initialSearch?: string;
}) {
  return (
    <AppDialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      title={
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, minWidth: 0 }}>
          <ArticleOutlinedIcon fontSize="small" />
          <Box
            component="span"
            sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
          >
            {title}
          </Box>
        </Box>
      }
      actions={<Button onClick={onClose}>Close</Button>}
    >
      {open && scope ? (
        <LogsView
          key={scope.kind === "job" ? `job-${scope.jobId}` : `task-${scope.taskId}`}
          scope={scope}
          canEdit={canEdit}
          readOnlyReason={readOnlyReason}
          initialSearch={initialSearch}
        />
      ) : null}
    </AppDialog>
  );
}
